const MS_PER_DAY = 1000 * 60 * 60 * 24
const AVG_MONTH_DAYS = 365.25 / 12

export interface DateDifferenceResult {
  totalDays: number
  totalWeeks: number
  fullWeeks: number
  remainingDays: number
  months: number
  years: number
  businessDays: number | null
  swapped: boolean
  rangeStart: Date
  rangeEnd: Date
}

interface DateDifferenceOptions {
  inclusive: boolean
  includeBusinessDays: boolean
}

export function calculateDateDifference(
  start: Date,
  end: Date,
  options: DateDifferenceOptions,
): DateDifferenceResult {
  const swapped = start.getTime() > end.getTime()
  const rangeStart = swapped ? end : start
  const rangeEnd = swapped ? start : end
  const totalDays = daysBetween(rangeStart, rangeEnd, options.inclusive)
  const months = approxMonths(rangeStart, rangeEnd)

  return {
    totalDays,
    totalWeeks: totalDays / 7,
    fullWeeks: Math.floor(totalDays / 7),
    remainingDays: totalDays % 7,
    months: Math.round(months * 100) / 100,
    years: Math.round((months / 12) * 100) / 100,
    businessDays: options.includeBusinessDays
      ? businessDaysBetween(rangeStart, rangeEnd, options.inclusive)
      : null,
    swapped,
    rangeStart,
    rangeEnd,
  }
}

function daysBetween(start: Date, end: Date, inclusive: boolean): number {
  const milliseconds = end.getTime() - start.getTime()
  const days = Math.round(milliseconds / MS_PER_DAY)
  return inclusive ? days + 1 : days
}

function approxMonths(start: Date, end: Date): number {
  const totalDays = (end.getTime() - start.getTime()) / MS_PER_DAY
  return totalDays / AVG_MONTH_DAYS
}

function isWeekend(date: Date): boolean {
  const day = date.getDay()
  return day === 0 || day === 6
}

function businessDaysBetween(start: Date, end: Date, inclusive: boolean): number {
  let count = 0
  const date = new Date(start)
  const endTime = end.getTime()

  while (date.getTime() <= endTime) {
    if (!isWeekend(date)) count++
    date.setDate(date.getDate() + 1)
  }

  return inclusive ? count : count - (isWeekend(end) ? 0 : 1)
}
